/** @format */

import React, { Component } from 'react';
import { Grid, Button, Icon } from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';

@inject('RequestsStore')
@observer
class OptionAvailableButtons extends Component {
  render() {
    const { RequestsStore } = this.props;
    const currentRequestId = RequestsStore.requestsParams.currentRequestId;
    return (
      <Grid>
        <Grid.Row columns={2}>
          <Grid.Column>
            <Button
              onClick={() =>
                RequestsStore.checkOption(
                  false,
                  currentRequestId,
                  this.props.partId,
                  this.props.optionKey,
                )
              }
              disabled={this.props.checked === false}
              fluid
              color="red"
              size="small"
            >
              <Icon name="cancel" />
              Non disponibile
            </Button>
          </Grid.Column>
          <Grid.Column>
            <Button
              onClick={() =>
                RequestsStore.checkOption(
                  true,
                  currentRequestId,
                  this.props.partId,
                  this.props.optionKey,
                )
              }
              disabled={this.props.checked === true}
              fluid
              color="green"
              size="small"
            >
              <Icon name="check" />
              Disponibile
            </Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default OptionAvailableButtons;
